import { Pipe, PipeTransform } from '@angular/core';
import { UsStateAbbreviation, VariableTitleCasePipe } from '@aiwyn/shared';

const STATE_NAME_OVERRIDES: Record<string, string> = {
  [UsStateAbbreviation.WASHINGTON_DC]: 'Washington, D.C.',
};

@Pipe({
  name: 'usStateNameTitleCase',
  standalone: false,
})
export class UsStateNameTitleCasePipe extends VariableTitleCasePipe implements PipeTransform {
  transform(stateAbbreviation: string): string {
    return UsStateNameTitleCasePipe.staticTransform(stateAbbreviation);
  }

  static staticTransform(stateAbbreviation: string): string {
    if (!stateAbbreviation) {
      return '';
    }

    // use override if it exists
    if (STATE_NAME_OVERRIDES[stateAbbreviation]) {
      return STATE_NAME_OVERRIDES[stateAbbreviation];
    }

    const [rawStateName] = Object.entries(UsStateAbbreviation)
      .find(([, stateAbbreviationValue]) => stateAbbreviationValue === stateAbbreviation) ?? [''];

    return super.staticTransform(rawStateName);
  }
}
